<p-dialog
  [(visible)]="displayModal"
  modal="modal"
  [draggable]="false"
  responsive="true"
  appendTo="body"
>
  <p-header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
    </div>
    <span #mod tabindex="0"></span>
    <h3>{{ displayData?.heading }}</h3>
  </p-header>
  <p class="small">{{ displayData?.subHeading }}</p>
  <p-footer>
    <div class="buttons-container button-spacing text-center">
      <button class="btn btn-primary" (click)="closeModal()" id="close-document-error-modal">
        {{ displayData?.ctaText }}
      </button>
    </div>
  </p-footer>
</p-dialog>
